/**
 * Utility function to merge class names (similar to clsx/tailwind-merge)
 */
export function cn(...inputs) {
  return inputs
    .filter(Boolean)
    .join(' ')
    .split(' ')
    .filter((value, index, self) => self.indexOf(value) === index)
    .join(' ');
}
